import { render, staticRenderFns } from "./contactUsItem.vue?vue&type=template&id=1073e5a3&scoped=true&"
import script from "./contactUsItem.vue?vue&type=script&lang=js&"
export * from "./contactUsItem.vue?vue&type=script&lang=js&"
import style0 from "./contactUsItem.vue?vue&type=style&index=0&id=1073e5a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073e5a3",
  null
  
)

export default component.exports